angular
	.module 'App.Module.BulkDataLog', []
	.config ($stateProvider) ->
		$stateProvider
			.state 'bulk_data_logs',
				url: '/bulk_data_logs',
				views:
					main:
						controller: 'BulkDataLogController'
						controllerAs: 'vm'
						templateUrl: '@app/bulk-data-log/bulk-data-log.view.html'
				data:
					hideSubMenu: true
